import { icClose } from '@vivareal/lina-icons'
import QUICK_FILTERS from '@/fixture/quick-filters'
import tracker from './oz-quick-filters.tracker'

export default {
  name: 'oz-quick-filters',

  props: {
    filters: {
      type: Object,
      required: true,
    },
  },

  data () {
    return {
      icons: {
        icClose,
      },
    }
  },

  watch: {
    filters: {
      handler () {
        this.setQuickFilters()
      },
      deep: true,
    },

    quickFilters () {
      this.setQuickFilters()
    },
  },

  computed: {
    quickFilters: {
      get () {
        const { business, listingType } = this.filters
        return QUICK_FILTERS[listingType === 'DEVELOPMENT' ? listingType : business] || []
      },
      set (newQuickFilters) {
        return newQuickFilters
      },
    },

    showQuickFilters () {
      return this.quickFilters.length
    },
  },

  created () {
    this.setQuickFilters()
  },

  methods: {
    onClickPill (pillIndex) {
      const pillClicked = this.quickFilters[pillIndex]
      const selected = !pillClicked.selected

      this.quickFilters.splice(pillIndex, 1, {
        ...pillClicked,
        selected,
      })

      this.track(pillClicked)

      const currentFilters = this.getCurrentFilters(pillClicked.filters, selected)
      this.$emit('filters:update', currentFilters)
    },

    track ({ filters, selected, text }) {
      const action = selected ? 'REMOVE QUICK FILTER' : 'ADD QUICK FILTER'
      const { business: businessType } = this.filters

      const { parkingSpaces, bedrooms, bathrooms } = filters

      const toNumber = (val) => Number(val || '') || undefined

      const transformAmenities = Object.entries({ parkingSpaces, bedrooms, bathrooms })
        .reduce((treatedObj, [key, value]) => {
          if (!value) {
            return treatedObj
          }

          const mountObj = { [key]: [toNumber(value)] }
          return { ...treatedObj, ...mountObj }
        }, {})

      tracker.quickFilterClicked({
        action,
        businessType,
        filters: {
          ...filters,
          ...transformAmenities,
        },
        text,
      })
    },

    getCurrentFilters (quickFilter, isSelected) {
      const [newAmenitie] = quickFilter.amenities || []
      const amenitiesSelected = this.filters.amenities || []

      if (isSelected) {
        const amenities = { amenities: [...amenitiesSelected] }

        if (newAmenitie) amenities.amenities.push(newAmenitie)

        return {
          ...this.filters,
          ...quickFilter,
          ...amenities,
        }
      }

      let currentFilters = this.filters

      Object.keys(quickFilter).forEach((filter) => {
        if (filter === 'amenities') {
          const remainingAmenities = amenitiesSelected
            .filter((amenitie) => amenitie !== newAmenitie)

          currentFilters = {
            ...currentFilters,
            amenities: remainingAmenities,
          }
          return
        }

        delete currentFilters[filter]
      })

      return currentFilters
    },

    setQuickFilters () {
      this.quickFilters = this.quickFilters.map((pill) => {
        const quickFilterSelected = Object.entries(pill.filters).every(([key, value]) => {
          const filterSelected = this.filters[key]

          if (!filterSelected && filterSelected !== 0) return false

          return key === 'amenities' ? filterSelected.includes(value[0]) : filterSelected === value
        })

        pill.selected = quickFilterSelected
        return pill
      })
    },
  },
}
